// modules
import React from 'react';
import PropTypes from 'prop-types';

// local
import './Feature.css';


const Feature = ({ imgUrl, text }) => (
    <div className={ 'Feature__item' }>
        <img className={ 'Feature__icon' } src={ imgUrl } alt={ 'icon' } />
        <p className={ 'Feature__text' }>{ text }</p>
    </div>
);

Feature.propTypes = {
    imgUrl: PropTypes.string,
    text: PropTypes.string,
};

export default Feature;



// WEBPACK FOOTER //
// ./src/components/FeatureList/components/Feature/index.js